import script from "./autoLogin.vue?vue&type=script&setup=true&lang=ts"
export * from "./autoLogin.vue?vue&type=script&setup=true&lang=ts"

import "./autoLogin.vue?vue&type=style&index=0&id=2d82dbd6&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d82dbd6"]])

export default __exports__